import { render, staticRenderFns } from "./SuccessComponent.vue?vue&type=template&id=ca2b3ea0&scoped=true"
import script from "./SuccessComponent.vue?vue&type=script&lang=js"
export * from "./SuccessComponent.vue?vue&type=script&lang=js"
import style0 from "./SuccessComponent.vue?vue&type=style&index=0&id=ca2b3ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b3ea0",
  null
  
)

export default component.exports